import {
  createAsyncThunk,
  createEntityAdapter,
  createSlice,
} from "@reduxjs/toolkit";
import {
  getDistributorStock,
  distributorStockLogs,
  distributorStockTransaction,
  getDistributorStockHistory,
} from "data/server_apis/inventoryService";

const distributorStockAdapter = createEntityAdapter({
  selectId: (distributorStock) => distributorStock.id,
});

const distributorStockLogAdapter = createEntityAdapter({
  selectId: (log) => log.id,
});

export const distributorStockTransactionThunk = createAsyncThunk(
  "distributorStock/create",
  async ({ stock, data }, { rejectWithValue }) => {
    try {
      return (await distributorStockTransaction(data)).data;
    } catch (err) {
      const customError = {
        name: err.response?.status,
        message: err.response?.status === 400 ? err.response?.data : null,
      };
      // console.log("Error", customError);
      return rejectWithValue(customError);
    }
  }
);
export const getDistributorStockLogsThunk = createAsyncThunk(
  "distributorStockLogs/get",
  async ({ page, from_date, to_date, distributor }, { rejectWithValue }) => {
    try {
      return (await distributorStockLogs(page, from_date, to_date, distributor))
        .data;
    } catch (err) {
      const customError = {
        name: err.response?.status,
        message: err.response?.status === 400 ? err.response?.data : null,
      };
      // console.log("Error", customError);
      return rejectWithValue(customError);
    }
  }
);

export const getDistributorStockThunk = createAsyncThunk(
  "distributorStock/get",
  async (distributor, { rejectWithValue }) => {
    try {
      return (await getDistributorStock(distributor)).data;
    } catch (err) {
      const customError = {
        name: err.response?.status,
        message: err.response?.status === 400 ? err.response?.data : null,
      };
      // console.log("Error", customError);
      return rejectWithValue(customError);
    }
  }
);

export const getDistributorStockHistoryThunk = createAsyncThunk(
  "distributorStockHistory/get",
  async ({time,distributor}, { rejectWithValue }) => {
    try {
      return (await getDistributorStockHistory(time,distributor)).data;
    } catch (err) {
      const customError = {
        name: err.response?.status,
        message: err.response?.status === 400 ? err.response?.data : null,
      };
      // console.log("Error", customError);
      return rejectWithValue(customError);
    }
  }
);

const distributorStockSlice = createSlice({
  name: "distributorStack",
  initialState: distributorStockAdapter.getInitialState({
    distributorStockStatus: {},
    distributorStockTransactionStatus: {},
    logs: distributorStockLogAdapter.getInitialState(),
    logStatus: {},
    logPageCount: 1,
    history: [],
    historyStatus: {},
  }),
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(distributorStockTransactionThunk.pending, (state, action) => {
        state.distributorStockTransactionStatus = { loading: "get" };
      })
      .addCase(distributorStockTransactionThunk.rejected, (state, action) => {
        state.distributorStockTransactionStatus = {
          error: "get",
          errorMessage: action.payload?.message,
        };
      })
      .addCase(distributorStockTransactionThunk.fulfilled, (state, action) => {
        state.distributorStockTransactionStatus = {
          success: "get",
          errorMessage: action.payload?.message,
        };
        if (
          action.meta.arg.data.in_or_out === "ret" ||
          action.meta.arg.data.in_or_out === "out"
        ) {
          const stock = { ...action.meta.arg.stock };
          stock.qty -= action.payload.qty;
          distributorStockAdapter.updateOne(state, {
            id: action.meta.arg.stock.id,
            changes: stock,
          });
        }
      });

    builder
      .addCase(getDistributorStockThunk.pending, (state, action) => {
        state.distributorStockStatus = { loading: "get" };
      })
      .addCase(getDistributorStockThunk.rejected, (state, action) => {
        state.distributorStockStatus = {
          error: "get",
          errorMessage: action.payload?.message,
        };
      })
      .addCase(getDistributorStockThunk.fulfilled, (state, action) => {
        state.distributorStockStatus = {
          success: "get",
        };
        distributorStockAdapter.setAll(state, action.payload);
      });

    builder.addCase(getDistributorStockLogsThunk.fulfilled, (state, action) => {
      distributorStockLogAdapter.setAll(state.logs, action.payload.results);
      state.logPageCount = action.payload.total_pages;
    });

    builder
      .addCase(getDistributorStockHistoryThunk.pending, (state, action) => {
        state.getMainStockHistory = { loading: "get" };
      })
      .addCase(getDistributorStockHistoryThunk.rejected, (state, action) => {
        state.getMainStockHistory = {
          error: "get",
          errorMessage: action.payload?.message,
        };
      })
      .addCase(getDistributorStockHistoryThunk.fulfilled, (state, action) => {
        state.getMainStockHistory = {
          success: "get",
        };
        state.history = action.payload;
      });
  },
});

export const {} = distributorStockSlice.actions;
export const distributorStockSelector = distributorStockAdapter.getSelectors(
  (state) => state.distributorStock
);

export const distributorStockLogSelector =
  distributorStockLogAdapter.getSelectors(
    (state) => state.distributorStock.logs
  );

export default distributorStockSlice.reducer;
